<template>
  <label
    class="field"
    :class="{
      '-combo-left': combo == 'left',
      '-combo-right': combo == 'right',
    }"
  >
    <label class="label"
      >{{ label
      }}<span class="little-label" v-if="littleLabel">
        {{ littleLabel }}</span
      ></label
    >
    <input
      v-if="type !== 'textarea'"
      class="input"
      :class="{ '-password': type == 'password' }"
      :type="toggleType"
      :name="label"
      :id="label"
      :value="value"
      @input="$emit('update:value', $event.target.value)"
    />
    <textarea
      v-else
      class="input"
      rows="4"
      :name="label"
      :id="label"
      :value="value"
      @input="$emit('update:value', $event.target.value)"
      :placeholder="placeholder"
    ></textarea>
    <div
      class="password-toggle"
      v-if="type == 'password'"
      @click.prevent="
        toggleType = toggleType == 'password' ? 'text' : 'password'
      "
    ></div>
    <span class="error" :class="{ '-visible': errorMessage }">{{
      errorMessage
    }}</span>
  </label>
</template>

<script>
export default {
  props: {
    label: String,
    littleLabel: String,
    type: {
      type: String,
      default: "text",
    },
    value: String,
    combo: [Boolean, String],
    errorMessage: String,
    placeholder: String,
  },
  data() {
    return {
      toggleType: this.type,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "foundation-sites/scss/foundation.scss";
@import "@/assets/scss/_settings";
.field {
  font: 600 18px/1.2 CenturyGothic;
  color: #fff;
  display: block;
  margin-bottom: 1em;
  position: relative;
  &.-combo- {
    @include breakpoint(medium) {
      &right {
        margin-left: 1em;
      }
      &left {
        margin-right: 1em;
      }
    }
  }
}
.label {
  margin-bottom: 0.3em;
  display: block;
}
.input {
  width: 100%;
  display: block;
  border: 2px solid #00205b;
  font: 17px/1 CenturyGothic;
  color: #00205b;
  padding: 8px 12px;
  outline: 0;
  &.-password {
    padding-right: 32px;
  }
}
.little-label {
  font-size: 0.8em;
  font-weight: normal;
}
.password-toggle {
  display: block;
  height: 1.8em;
  width: 1.8em;
  cursor: pointer;
  background-position: center;
  background-size: contain;
  position: absolute;
  bottom: 5px;
  right: 5px;
  background-image: url("~@/assets/images/eye.svg");
}
.error {
  position: absolute;
  background-color: #fcfcfc;
  border-left: 12px solid #f00;
  color: #f00;
  display: none;
  font-size: 13px;
  font-weight: 400;
  margin-top: 10px;
  padding: 10px 10px 10px 36px;
  position: relative;
  &::before {
    background-image: url("~@/assets/images/error.svg");
    content: '';
    height: 21px;
    left: 8px;
    position: absolute;
    top: 7px;
    width: 21px;
  }
  &.-visible {
    display: inline-block;
  }
}
</style>
